<section class="unit-member-current-status" aria-live="polite">
  <div class="status-loading" *ngIf="loading">
    <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
    Loading current status...
  </div>

  <div class="status-error" *ngIf="!loading && errorMessage">
    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
    <span>{{ errorMessage }}</span>
    <button type="button" class="btn btn-link btn-sm" (click)="refresh()">Try again</button>
  </div>

  <div *ngIf="!loading && !errorMessage && member"
       class="status-card"
       [class.status-current]="member.TrainingCurrent"
       [class.status-not-current]="!member.TrainingCurrent">
    <div class="status-icon" aria-hidden="true">
      <i class="fa" [class.fa-check-circle]="member.TrainingCurrent"
         [class.fa-exclamation-circle]="!member.TrainingCurrent"></i>
    </div>
    <div class="status-content">
      <strong>{{ member.TrainingCurrent ? 'Current' : 'Not Current' }}</strong>
      <div class="status-reason">
        {{ member.TrainingCurrentReason || (member.TrainingCurrent ? 'All requirements are current.' : 'Current status details are unavailable.') }}
      </div>
      <small *ngIf="evaluatedLocal">Evaluated {{ evaluatedLocal }}</small>
    </div>
    <button type="button" class="btn btn-link btn-sm status-refresh" (click)="refresh()" title="Refresh current status">
      <i class="fa fa-refresh" aria-hidden="true"></i>
      Refresh
    </button>
  </div>
</section>
